import { REQUEST_PRICING, RECEIVE_PRICING } from "./pricing.actions";

const requestPricing = () => {
    return {
        type: REQUEST_PRICING
    };
};

const receivePricing = pricing => {
    const pricingItems = pricing.map(item => {
        return {
            value: item.title.rendered,
            label: item.title.rendered,
            pricing: {
                mobile: parseFloat(item.acf.mobile),
                landline: parseFloat(item.acf.landline),
                sms: parseFloat(item.acf.sms)
            }
        };
    });

    return {
        type: RECEIVE_PRICING,
        pricingItems
    };
};

export { requestPricing, receivePricing };



// WEBPACK FOOTER //
// ./src/actions/pricing/pricing.creators.js